// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610072005/js/" + chunkId + "." + {"44":"9797e673","225":"a7810670","481":"8b712e17","486":"59377b54","770":"6f3c7604"}[chunkId] + ".0.2251221553208932.chunk.js";
};